import {getFullName} from "../../utils/getFullName";
import Avatar from "../../assets/icons/Avatar";
import {StatusView} from "../messages/StatusView";
import {getFriendlyTimeDifferenceV2} from "../../utils/friendlyDate";
import React from "react";
import {ConversationRow} from "../../types/ConversationProps";
import useAppContext from "../../hooks/useAppContext";
import {setConversationsAsSeen} from "../../api/setConversationsAsSeen";
import useUserContext from "../../hooks/useUserContext";

interface ConversationRoomListProps {
    roomFilter: string;
    roomSearchKey: string;
    currentConversation: ConversationRow | null;
    setCurrentConversation: (newCurrent: ConversationRow | null) => void;
}

const ConversationRoomList = ({ roomFilter, roomSearchKey, currentConversation, setCurrentConversation }: ConversationRoomListProps) => {
    const { data: { conversations, conversationMessages }, actions: { setCurrentConversationId, loadConversationMessages, addMessageToConversation, setConversationAsSeen } } = useAppContext();
    const { selectedDomain } = useUserContext();

    const isInSearch = (conversationRow: ConversationRow) => {
        if(!roomSearchKey) return true;
        const clientName = getFullName(conversationRow.firstName, conversationRow.lastName) || conversationRow.guestName;
        return clientName?.toLowerCase().includes(roomSearchKey.toLowerCase());
    }

    const isFilteredIn = (conversationRow: ConversationRow) => {
        if(!isInSearch(conversationRow)) return false;
        if(roomFilter === 'active' && (!conversationRow.activationWindowDeadline || new Date(conversationRow.activationWindowDeadline) <= new Date())) return false;
        return true;
    }

    const selectConversation = (conversationRow: ConversationRow) => {
        setCurrentConversation(conversationRow);
        setCurrentConversationId(conversationRow.id);
        if(selectedDomain) {
            setConversationAsSeen(conversationRow.id);
            setConversationsAsSeen(selectedDomain, conversationRow.id);
        }
    }

    return (
        <>
            {conversations.data.filter(isFilteredIn).slice(0,50).map((conversationRow: ConversationRow) => {
                const clientName = getFullName(conversationRow.firstName, conversationRow.lastName) || conversationRow.guestName;
                const isWindowActive = conversationRow.activationWindowDeadline ? new Date(conversationRow.activationWindowDeadline) > new Date() : false;
                const isWidgetConversation = !!conversationRow.widgetSessionId;
                return (
                    <div className={`chat-room-row ${conversationRow.id === currentConversation?.id ? 'selected' : ''}`}
                         key={`${clientName}-${conversationRow.id}`} onClick={() => selectConversation(conversationRow)}>
                        <div className="left">
                            <div className={`image ${isWidgetConversation ? 'widget' : isWindowActive ? 'active' : ''}`}>
                                {conversationRow.image ? <img src={conversationRow.image} alt={clientName}/> :
                                    conversationRow.firstName && conversationRow.lastName ?
                                        <div className="initial-letters">{conversationRow.firstName.substring(0,1).toUpperCase()}{conversationRow.lastName.substring(0,1).toUpperCase()}</div>
                                        : conversationRow.firstName ?
                                            <div className="initial-letters">{conversationRow.firstName.substring(0,1).toUpperCase()}</div>
                                            : <Avatar width={40} height={40} color="#fff"/>}
                            </div>
                            {conversationRow.unreadMessagesCount ?
                                <div className="badge">{conversationRow.unreadMessagesCount}</div> : null}
                            <div className="room-previews">
                                <div className="chat-room-title">{clientName} <span>{isWidgetConversation ? ' (Support)' : ''}</span></div>
                                {conversationRow.content ? <div className="chat-room-preview">
                                    {!conversationRow.sentByClient ?
                                        <div className={`message-status ${conversationRow.status?.toLowerCase()}`}>
                                            <StatusView value={conversationRow.status || 'UNKNOWN'}
                                                        errorMessage={conversationRow.errorMessage}/></div> : null}
                                    <span>{conversationRow.content}</span>
                                </div> : null}
                            </div>
                        </div>
                        <div className="right">
                            {conversationRow.time ? <div
                                className="time">{getFriendlyTimeDifferenceV2(new Date(conversationRow.time))}</div> : null}
                        </div>
                    </div>
                )
            })}
        </>
    )
}

export default ConversationRoomList;